import { createBaseService } from '~/services/base.axios.service.js'
import { getRequestHeadersProclaim } from '~/services/request.headers.js'

if (!import.meta.env.VITE_PROCLAIM_API_BASE?.trim()) {
  throw new Error('VITE_PROCLAIM_API_BASE is required')
}

const service = createBaseService(getRequestHeadersProclaim, import.meta.env?.VITE_PROCLAIM_API_BASE)

export default service
